module.exports = __webpack_public_path__ + "img/about/80243-047.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-047.png
// module id = 46
// module chunks = 0